import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import editableTableStyles from "../accounting/editableTable/EditableTable.module.scss";
import { FinancialAccount } from "../../common/types/financialAccount";
import { IntegrationAccount } from "../../common/types/integrationAccount";
import { getAnonymousAccountNumber } from "../../common/helpers/bankAccount";
import { ArrowDownIcon } from "../../icons";
import styles from "./ImporterPage.module.scss";

export interface IntegrationAccountChangePayload {
    originalAccountNumber: string | null;
    originalAccountName: string | null;
}

interface Props {
    selectedFinancialAccount?: FinancialAccount;
    integrationAccount: IntegrationAccount;
    onAccountChanged: (payload: IntegrationAccountChangePayload) => void;
}

export const ImporterAccountPickerTrigger: React.FC<Props> = ({
    selectedFinancialAccount,
    integrationAccount,
    onAccountChanged,
}) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        const displayedValue = selectedFinancialAccount
            ? getAnonymousAccountNumber(
                  selectedFinancialAccount.accountNumberMask ?? "",
              )
            : integrationAccount.originalAccountNumber ??
              integrationAccount.originalAccountName ??
              "";

        setValue(displayedValue);
    }, [
        selectedFinancialAccount,
        integrationAccount.originalAccountNumber,
        integrationAccount.originalAccountName,
    ]);

    const inputBlocked = Boolean(selectedFinancialAccount);

    const onClickInput = (e: React.MouseEvent<HTMLInputElement>) => {
        if (!inputBlocked) {
            e.stopPropagation();
        }
    };

    const onChangeInput = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setValue(e.target.value);
        },
        [],
    );

    const onBlurInput = useCallback(() => {
        if (/^\d+$/.test(value)) {
            onAccountChanged({
                originalAccountNumber: value,
                originalAccountName: null,
            });
        } else {
            onAccountChanged({
                originalAccountNumber: null,
                originalAccountName: value,
            });
        }
    }, [onAccountChanged, value]);

    return (
        <div className={styles.accountPickerTrigger}>
            <input
                value={value}
                className={classNames(
                    "form-control",
                    "form-control-sm",
                    editableTableStyles.editableTableInput,
                    styles.accountPickerTriggerInput,
                    {
                        [styles.accountPickerTriggerInputBlocked]: inputBlocked,
                    },
                )}
                onChange={onChangeInput}
                onClick={onClickInput}
                onBlur={onBlurInput}
                readOnly={inputBlocked}
            />
            <ArrowDownIcon className={styles.accountPickerTriggerIcon} />
        </div>
    );
};
